import {
    Component,
    Input,
    ViewChild,
    TemplateRef,
    ElementRef,
    ViewContainerRef,
    Output,
    EventEmitter, OnInit, OnChanges, SimpleChanges
} from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { IamService } from '../../../../module/iam/iam.service';
import { debounceTime, distinctUntilChanged, Subscription } from 'rxjs';
import { PaginatedModel } from '../pagination/model/paginated.model';
import { UserModel } from '../../../../module/iam/user-settings/model/user.model';

@Component({
    selector: 'app-user-select',
    templateUrl: './user-select.component.html',
    styleUrl: './user-select.component.scss'
})
export class UserSelectComponent implements OnInit, OnChanges {
    @Input() label: string = '';
    @Input() icon = 'uii-user';
    @Input() readonly: boolean = false;
    @Input() viewMode: 'select' | 'badges' = 'select';
    @Input() selectedUserId: string | undefined = undefined;
    @Input() emitOnInit = true;
    @Input() userFilter: 'all' | 'patients' = 'all';

    @Output() changed = new EventEmitter<UserModel>();

    @ViewChild('trigger') trigger!: ElementRef;
    @ViewChild('dropdownTemplate') menuTemplate!: TemplateRef<any>;

    overlayRef!: OverlayRef;

    isEditing = true;
    userFilterValue: string = '';
    users: Array<UserModel> = [];
    selectedUser: UserModel | null = null;
    request: Subscription = new Subscription();
    searching = true;

    constructor(
        protected iamService: IamService,
        private overlay: Overlay,
        private viewContainerRef: ViewContainerRef
    ) {}

    public ngOnInit(): void {
        if (!this.readonly) {
            this.searchUsers();
        }
    }
    public ngOnChanges(changes: SimpleChanges): void {
        this.initializeUser();
    }
    protected initializeUser(): void {
        if (this.selectedUserId) {
            this.iamService.getUser(this.selectedUserId).subscribe((user: UserModel) => {
                this.selectedUser = user;
                this.changed.emit(this.selectedUser);
            });
        } else {
            this.selectedUser = null;
        }
    }
    public eventOpenOptions(): void {
        if (this.overlayRef) {
            this.overlayRef.dispose();
        }
        const positionStrategy = this.overlay.position()
            .flexibleConnectedTo(this.trigger)
            .withPositions([
                {
                    originX: 'start',
                    originY: 'bottom',
                    overlayX: 'start',
                    overlayY: 'top',
                    offsetY: 8,
                }
            ]);

        const triggerWidth = this.trigger.nativeElement.getBoundingClientRect().width;
        this.overlayRef = this.overlay.create({
            positionStrategy,
            hasBackdrop: true,
            width: triggerWidth,
            minWidth: triggerWidth,
            backdropClass: 'cdk-overlay-transparent-backdrop',
            scrollStrategy: this.overlay.scrollStrategies.reposition()
        });

        this.overlayRef.backdropClick().subscribe(() => { this.overlayRef.dispose();});

        const menuTemplateBuilt = new TemplatePortal(this.menuTemplate, this.viewContainerRef);

        this.overlayRef.attach(menuTemplateBuilt);
    }

    protected handleUsers(users: PaginatedModel<UserModel>): void {
        this.users = users.items;

        if (this.selectedUser) {
            const haveUser = this.users.find((user) => user._id === this.selectedUser?._id);
            if (!haveUser) {
                this.users.unshift(this.selectedUser);
            }
        }

    }
    public eventUserChanged(user: UserModel): void {
        if (user._id === this.selectedUser?._id) {
            this.selectedUser = null;
        } else {
            this.selectedUser = user;
        }
        this.isEditing = false;
        this.changed.emit(this.selectedUser as any);

        if (this.overlayRef) {
            this.overlayRef.dispose();
        }
    }

    public eventUserFilterChange(value: Event): void {
        this.userFilterValue = (value.target as HTMLInputElement).value;
        this.searchUsersByFilter(this.userFilterValue);
    }

    protected searchUsers(): void {
        this.request.unsubscribe();
        this.searchUsersByFilter('');
    }

    protected searchUsersByFilter(filter: string): void {
        this.request.unsubscribe();
        this.searching = true;

        this.request = this.iamService.getUsers(filter)
            .pipe(debounceTime(600), distinctUntilChanged())
            .subscribe((users) => {
                this.searching = false;
                this.handleUsers(users);
            });
    }
}
